import Vue from 'vue'
import Unlock from './UnlockModal'

const UnlockModal = Vue.extend(Unlock)

Unlock.install = function (data) {
  const instance = new UnlockModal({
    data
  }).$mount()

  document.body.appendChild(instance.$el)

  Vue.nextTick(() => {
    console.log(instance,'instance')
    const permissionList =this.$store.getters.roles.permissions
    const permission = permissionList.find((val) => {
      return val.permissionId === instance.router.name
    })
    console.log(permission,'permission')

    // const needSign=permission.actionList.findIndex((val) => {
    //   return val.no === instance.button&&val.signable
    // }) > -1
    //
    const action = permission.actionList.find((val) => {
      return val.no === instance.button
    })
    if(!(action.unlockCategory===undefined)){
      instance.category = action.unlockCategory
      instance.reason = action.unlockCategory.name
      instance.visible = true
    }

  })
}

export default Unlock